var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYuanSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(32,196,203)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 53.329 56.008 h -23.05 c -1.657 0 -3 -1.343 -3 -3 s 1.343 -3 3 -3 h 23.05 c 1.657 0 3 1.343 3 3 S 54.986 56.008 53.329 56.008 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(27,167,173)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 53.329 66.816 h -23.05 c -1.657 0 -3 -1.343 -3 -3 s 1.343 -3 3 -3 h 23.05 c 1.657 0 3 1.343 3 3 S 54.986 66.816 53.329 66.816 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(27,167,173)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 41.804 81.715 c -1.657 0 -3 -1.343 -3 -3 V 44.394 l -18.94 -19.179 c -1.164 -1.179 -1.152 -3.078 0.027 -4.243 c 1.178 -1.163 3.078 -1.152 4.243 0.027 l 19.805 20.056 c 0.554 0.562 0.865 1.319 0.865 2.108 v 35.553 C 44.804 80.372 43.461 81.715 41.804 81.715 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(27,167,173)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 41.804 81.715 c -1.657 0 -3 -1.343 -3 -3 V 43.162 c 0 -0.789 0.311 -1.546 0.865 -2.108 l 19.805 -20.056 c 1.164 -1.179 3.063 -1.191 4.243 -0.027 c 1.179 1.165 1.19 3.064 0.026 4.243 l -18.94 19.179 v 34.321 C 44.804 80.372 43.461 81.715 41.804 81.715 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(27,167,173)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 56.721 52.616 H 33.67 c -1.657 0 -3 -1.343 -3 -3 s 1.343 -3 3 -3 h 23.05 c 1.657 0 3 1.343 3 3 S 58.378 52.616 56.721 52.616 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 56.721 63.426 H 33.67 c -1.657 0 -3 -1.343 -3 -3 s 1.343 -3 3 -3 h 23.05 c 1.657 0 3 1.343 3 3 S 58.378 63.426 56.721 63.426 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45.196 78.323 c -1.657 0 -3 -1.343 -3 -3 V 41.002 l -18.94 -19.179 c -1.164 -1.179 -1.152 -3.078 0.027 -4.243 c 1.178 -1.164 3.079 -1.152 4.243 0.027 L 47.33 37.663 c 0.555 0.562 0.865 1.319 0.865 2.108 v 35.553 C 48.195 76.98 46.853 78.323 45.196 78.323 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45.196 78.323 c -1.657 0 -3 -1.343 -3 -3 V 39.771 c 0 -0.789 0.311 -1.546 0.865 -2.108 l 19.805 -20.056 c 1.165 -1.179 3.064 -1.19 4.243 -0.027 c 1.179 1.165 1.19 3.064 0.026 4.243 L 48.196 41.002 v 34.321 C 48.196 76.98 46.853 78.323 45.196 78.323 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYuanSign);
export default __webpack_public_path__ + "static/media/yuanSign.f3f9485da3d57ff4ccbf713e27834db9.svg";
export { ForwardRef as ReactComponent };